import { render } from "./ReportsTrainee.vue?vue&type=template&id=194f6164"
import script from "./ReportsTrainee.vue?vue&type=script&lang=js"
export * from "./ReportsTrainee.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__